module.exports = __webpack_public_path__ + "static/media/illustrationmap.b4c481b0.png";